import React, { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, PhoneIcon, AlertCircleIcon, XIcon } from 'lucide-react';
const examQuestions = [{
  question: 'A Limited Services Broker generally means',
  correctAnswer: 'a',
  options: [{
    letter: 'A',
    text: 'The listing broker will provide limited services, yet will still represent the seller'
  }, {
    letter: 'B',
    text: 'The listing broker will provide MLS access and signage yet will not represent the seller'
  }, {
    letter: 'C',
    text: 'The listing broker will not represent anyone in the transaction'
  }, {
    letter: 'D',
    text: "The listing broker will transfer the representation to the buyer's agent, thus making the buyer's agent a dual agent"
  }]
}, {
  question: 'Which of the following is most true about the Requirements for Licensees and Arizona Statutes?',
  correctAnswer: 'b',
  options: [{
    letter: 'A',
    text: 'The rules and statutes deal only with residential agents and do not apply to those selling commercial real estate'
  }, {
    letter: 'B',
    text: 'The rules and statutes refer to licensees and are not specific to residential or commercial, thus apply to all licensees'
  }, {
    letter: 'C',
    text: 'The rules and statutes specifically state that they apply to all licensees'
  }, {
    letter: 'D',
    text: 'The rules and statutes specifically exempt any licensee not selling residential real estate'
  }]
}, {
  question: 'The Code of Ethics of the National Association of Realtors',
  correctAnswer: 'd',
  options: [{
    letter: 'A',
    text: 'Demonstrate good business practices that non-members should follow'
  }, {
    letter: 'B',
    text: 'Must be following by all Realtor members'
  }, {
    letter: 'C',
    text: 'Are often duplicated in state rule and/or statute'
  }, {
    letter: 'D',
    text: 'All of the above'
  }]
}, {
  question: 'Part of the Requirements for Licensees in R4-28-1101.F that states the licensee should obtain "prior written consent" is addressing',
  correctAnswer: 'b',
  options: [{
    letter: 'A',
    text: "The licensee's obligation to disclose that they have a real estate license"
  }, {
    letter: 'B',
    text: "The licensee's obligation to obtain permission to be a dual agent"
  }, {
    letter: 'C',
    text: "The licensee's obligation to disclose the compensation that they are earning"
  }, {
    letter: 'D',
    text: 'All of the above'
  }]
}, {
  question: 'The AAR form titled "Disclosure of Buyer Agency and Seller Waiver and Confirmation" is used',
  correctAnswer: 'b',
  options: [{
    letter: 'A',
    text: 'When the seller is not represented'
  }, {
    letter: 'B',
    text: 'When the listing broker is providing limited services yet still represents the seller'
  }, {
    letter: 'C',
    text: 'When the buyer is not represented'
  }, {
    letter: 'D',
    text: 'All of the above'
  }]
}, {
  question: 'The obligation of a licensee to be fair and honest to all parties',
  correctAnswer: 'd',
  options: [{
    letter: 'A',
    text: 'Is part of the Arizona Commissioners Rules'
  }, {
    letter: 'B',
    text: 'Extends to both clients and customers'
  }, {
    letter: 'C',
    text: 'Is part of the Realtor Code of Ethics'
  }, {
    letter: 'D',
    text: 'All of the above'
  }]
}, {
  question: 'Which of the following would not create a dual agency?',
  correctAnswer: 'd',
  options: [{
    letter: 'A',
    text: 'The listing and selling agent are in the same office'
  }, {
    letter: 'B',
    text: 'The listing and selling agents, while in the same company, have never met each other before'
  }, {
    letter: 'C',
    text: 'The listing and selling agent are in the same company, but different branch offices'
  }, {
    letter: 'D',
    text: 'The listing and selling agents both work in a Keller Williams office, but the two different companies have different Designated Brokers'
  }]
}, {
  question: 'A fiduciary obligation',
  correctAnswer: 'a',
  options: [{
    letter: 'A',
    text: 'Is the highest obligation we can have in an agency relationship with the client'
  }, {
    letter: 'B',
    text: 'Only has obligations to client and no other party'
  }, {
    letter: 'C',
    text: 'Carries less obligation than the obligation to be fair and honest'
  }, {
    letter: 'D',
    text: 'All of the above'
  }]
}, {
  question: 'The main difference between an Exclusive Right to Sell listing and an Exclusive Agency listing is',
  correctAnswer: 'a',
  options: [{
    letter: 'A',
    text: 'The exclusive agency (EA) allows the seller to sell the property and not owe you compensation'
  }, {
    letter: 'B',
    text: 'The exclusive right (ER) is only invoked when there is a dual agency'
  }, {
    letter: 'C',
    text: 'The exclusive agency (EA) is only invoked when there is a dual agency'
  }, {
    letter: 'D',
    text: 'The exclusive right (ER) is used for residential while the exclusive agency is only used for commercial transactions'
  }]
}, {
  question: 'If a buyer wants to buy your listing and they are not represented',
  correctAnswer: 'c',
  options: [{
    letter: 'A',
    text: 'You must have an agent in your office represent them and write a contract'
  }, {
    letter: 'B',
    text: 'You must send them away and instruct them to obtain representation'
  }, {
    letter: 'C',
    text: 'You may be a dual agent if your broker allows it, or may represent the seller exclusively with full disclosure to the buyer'
  }, {
    letter: 'D',
    text: 'None of the above'
  }]
}, {
  question: 'If a seller breaches the contract and refuses to close, which of the following is most true?',
  correctAnswer: 'c',
  options: [{
    letter: 'A',
    text: "Only the buyer could sue the seller for damages; the listing agent and buyer's agent must arbitrate the dispute with the seller"
  }, {
    letter: 'B',
    text: 'The buyer could sue the seller for damages, and then would be obligated to pay the agents the compensation from their suit proceeds'
  }, {
    letter: 'C',
    text: 'The listing agent could sue the seller for their compensation and the buyer could sue the seller for damages'
  }, {
    letter: 'D',
    text: "The seller's only obligation under a breach would be to refund the buyer's earnest money"
  }]
}, {
  question: 'A buyer that is represented by a licensee wants to buy a property that is listed by the seller as a FSBO. Which of the following is true?',
  correctAnswer: 'b',
  options: [{
    letter: 'A',
    text: "The buyer's agent could write the contract but then the buyer would be obligated to pay the agent the compensation"
  }, {
    letter: 'B',
    text: "The buyer's agent might ask the seller to pay them; if not, then the buyer's agent might negotiate with the buyer to pay compensation at closing. Or the result might be the buyer's agent, while representing the buyer, does not receive any compensation"
  }, {
    letter: 'C',
    text: "The buyer's agent would be obligated to walk away and let the buyer negotiate direct with the seller"
  }, {
    letter: 'D',
    text: "The seller would automatically be obligated to pay the buyer's agent"
  }]
}, {
  question: 'The only difference between an EA (Exclusive Agency) and ER (Exclusive Right to Sell) Listing is',
  correctAnswer: 'c',
  options: [{
    letter: 'A',
    text: 'The EA is for commercial transaction while the ER is for residential'
  }, {
    letter: 'B',
    text: 'ARMLS and other statewide MLS groups have stopped publishing the Exclusive Right to Sell'
  }, {
    letter: 'C',
    text: 'The EA allows the seller to sell it themselves without owing compensation while the ER binds the seller to pay compensation regardless of how title is transferred'
  }, {
    letter: 'D',
    text: 'The ER is used within Maricopa County while the EA can be used state-wide'
  }]
}, {
  question: 'If a licensee is approached by a potential buyer at an open house',
  correctAnswer: 'd',
  options: [{
    letter: 'A',
    text: 'The licensee should immediately have the buyer sign an agency disclosure form'
  }, {
    letter: 'B',
    text: 'The licensee should immediately have the buyer sign the Exclusive Buyer/Broker form'
  }, {
    letter: 'C',
    text: 'The licensee should ask the buyer if they are working with another licensee'
  }, {
    letter: 'D',
    text: 'The licensee should ask the buyer if they are bound to a valid, existing, exclusive agreement with another licensee'
  }]
}, {
  question: 'Another licensee wrote an offer on your listing at full price, and your seller rejected that offer. Which of the following is true?',
  correctAnswer: 'c',
  options: [{
    letter: 'A',
    text: 'That is a "mirror-image" offer and the seller would owe the brokers the full compensation as noted on the listing agreement'
  }, {
    letter: 'B',
    text: 'The seller must accept any mirror-image offer'
  }, {
    letter: 'C',
    text: 'The seller may reject any offer, even full price, and would not owe any compensation'
  }, {
    letter: 'D',
    text: 'None of the above'
  }]
}, {
  question: 'Procuring cause would be based on',
  correctAnswer: 'b',
  options: [{
    letter: 'A',
    text: 'The fact that the licensee and the buyer were college roommates 12 years ago'
  }, {
    letter: 'B',
    text: 'The licensee that created a series events that brought a buyer to the decision to buy, without any break in the relationship'
  }, {
    letter: 'C',
    text: 'The fact that the licensee worked with the buyer for 10 weeks'
  }, {
    letter: 'D',
    text: 'The fact that the licensee claiming the compensation has been licensed far longer than the licensee that received the money at closing'
  }]
}, {
  question: 'For procuring cause to be considered, there must be',
  correctAnswer: 'd',
  options: [{
    letter: 'A',
    text: 'A transaction with the correct buyer and seller'
  }, {
    letter: 'B',
    text: 'The proper brokers named in the transaction'
  }, {
    letter: 'C',
    text: 'A successful close of escrow'
  }, {
    letter: 'D',
    text: 'All of the above'
  }]
}, {
  question: 'The point in time when a prospect becomes a client is when',
  correctAnswer: 'c',
  options: [{
    letter: 'A',
    text: 'The person calls you on the phone or walks into your open house'
  }, {
    letter: 'B',
    text: 'The person asks for services, such as to be shown a property'
  }, {
    letter: 'C',
    text: 'The person signs an agency disclosure form'
  }, {
    letter: 'D',
    text: 'All of the above'
  }]
}, {
  question: 'The Requirements for Licensees, Code of Ethics and Arizona Statutes require that we obtain prior written consent;',
  correctAnswer: 'c',
  options: [{
    letter: 'A',
    text: 'Before we have a client sign an agency disclosure form'
  }, {
    letter: 'B',
    text: 'Before we show any property'
  }, {
    letter: 'C',
    text: 'Before we act as a dual agent'
  }, {
    letter: 'D',
    text: 'Before we file a claim for procuring cause'
  }]
}, {
  question: 'While showing a prospect your listing, you ask them if they want to see a different property around the corner. They say yes. At that moment',
  correctAnswer: 'c',
  options: [{
    letter: 'A',
    text: 'They just became your client'
  }, {
    letter: 'B',
    text: 'You should have them execute an agency disclosure form as well as the Exclusive Buyer Broker Agreement'
  }, {
    letter: 'C',
    text: 'They just asked you for services'
  }, {
    letter: 'D',
    text: 'All of the above'
  }]
}, {
  question: 'A main benefit of the Buyer Broker Agreement is that the buyer',
  correctAnswer: 'c',
  options: [{
    letter: 'A',
    text: 'Would feel obligated to only buy a property with the licensee that asked them to sign the form'
  }, {
    letter: 'B',
    text: 'Would owe the licensee the full agreed-upon compensation if they bought a property without the licensee'
  }, {
    letter: 'C',
    text: 'Would owe the licensee the balance of any compensation due the licensee as a result of a sale'
  }, {
    letter: 'D',
    text: 'All of the above'
  }]
}, {
  question: 'Article 26 of the Arizona Constitution says that',
  correctAnswer: 'c',
  options: [{
    letter: 'A',
    text: 'We may not act as dual agents in certain transactions'
  }, {
    letter: 'B',
    text: 'We must exclusively represent any buyer that signs our agency addendum'
  }, {
    letter: 'C',
    text: 'We must represent one or both parties and thus, may not be facilitators'
  }, {
    letter: 'D',
    text: 'All of the above'
  }]
}, {
  question: 'If the buyer of your listing elects not to have any representation, you as the listing agent should',
  correctAnswer: 'b',
  options: [{
    letter: 'A',
    text: 'Warn them that it is dangerous not to have representation'
  }, {
    letter: 'B',
    text: 'Be prepared to work with them and assist them in the process'
  }, {
    letter: 'C',
    text: 'Send them away and tell them to find an agent to represent them'
  }, {
    letter: 'D',
    text: 'Ask the seller if you are permitted to reject any representation of the buyer'
  }]
}, {
  question: 'Agency in Arizona is provided by the Designated Broker through',
  correctAnswer: 'a',
  options: [{
    letter: 'A',
    text: 'Brokerage Agency'
  }, {
    letter: 'B',
    text: 'Single Agency'
  }, {
    letter: 'C',
    text: 'Office Agency'
  }, {
    letter: 'D',
    text: 'Any of the above'
  }]
}, {
  question: 'A Buyer Broker Agreement is a bi-lateral agreement, meaning',
  correctAnswer: 'a',
  options: [{
    letter: 'A',
    text: 'Both parties have specific obligations to perform in the contract'
  }, {
    letter: 'B',
    text: 'It is different from an Exclusive Listing Agreement since a listing agreement only binds one party'
  }, {
    letter: 'C',
    text: 'Both parties are obligated to pay a compensation'
  }, {
    letter: 'D',
    text: 'It must be signed with a contract or listing agreement'
  }]
}];
export function FinalExam() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const navigate = useNavigate();
  const displayName = slug?.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') || 'Class';
  const [answers, setAnswers] = useState<Record<number, string>>({});
  const [submitted, setSubmitted] = useState(false);
  const [sectionReview, setSectionReview] = useState('');
  const [showUnansweredModal, setShowUnansweredModal] = useState(false);
  const [unansweredList, setUnansweredList] = useState<number[]>([]);
  const handleAnswer = (questionIndex: number, answer: string) => {
    if (submitted) return;
    setAnswers(prev => ({
      ...prev,
      [questionIndex]: answer
    }));
  };
  const handleSubmit = () => {
    const unanswered: number[] = [];
    examQuestions.forEach((_, i) => {
      if (!answers[i]) unanswered.push(i + 1);
    });
    if (unanswered.length > 0) {
      setUnansweredList(unanswered);
      setShowUnansweredModal(true);
      return;
    }
    setSubmitted(true);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const scrollToQuestion = (qNum: number) => {
    setShowUnansweredModal(false);
    setTimeout(() => {
      const el = document.getElementById(`exam-q-${qNum - 1}`);
      if (el) el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }, 100);
  };
  const correctCount = examQuestions.filter((q, i) => answers[i] === q.correctAnswer).length;
  const score = Math.round(correctCount / examQuestions.length * 100);
  const passed = score >= 80;
  return <div className="space-y-0 -m-4 lg:-m-8" data-id="element-2021" data-mp="3vqxt6qozw8wo">
      {/* Top Header Bar */}
      <div className="bg-white border-b border-slate-200 px-4 lg:px-6 py-3" data-id="element-2022" data-mp="3vt1wb6f2l3vw">
        <div className="flex items-center justify-between max-w-7xl mx-auto" data-id="element-2023" data-mp="dk1af6q00cer">
          <div className="flex items-center gap-4" data-id="element-2024" data-mp="9jhda35fd8sm">
            <Link to={`/student/class/${slug}`} className="inline-flex items-center gap-1.5 text-xs text-purple-700 hover:text-purple-900 transition-colors" data-id="element-2025" data-mp="9hwm8nibk7zi">
              <ArrowLeftIcon className="h-3.5 w-3.5" data-id="element-2026" data-mp="3cymxphwo7d8l" />
              Back
            </Link>
            <div className="flex items-center gap-2 text-xs text-slate-500" data-id="element-2027" data-mp="3qtz2ki4jik38">
              <PhoneIcon className="h-3 w-3" data-id="element-2028" data-mp="3lzl4u92eo0ve" />
              <span data-id="element-2029" data-mp="2ybbnbjc85za2">For Class Support: Call or text: 602-377-6207</span>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-2030" data-mp="2ua89119tsbay">
            {/* Leave Class button */}
            <Link to={`/student/class/${slug}`} className="inline-flex items-center px-3 py-1.5 text-xs font-bold text-white rounded transition-colors hover:opacity-90" style={{
            backgroundColor: '#CC0000'
          }} data-id="element-2031" data-mp="2k6bbhppwrklp">
              Leave/Pause Class
            </Link>
          </div>
        </div>
      </div>

      {/* Course Title */}
      <div className="text-center py-6 bg-white border-b border-slate-200" data-id="element-2032" data-mp="32vzseewxd0i2">
        <h1 className="text-2xl font-bold text-slate-900 mb-1" data-id="element-2033" data-mp="37vm1qd9mtwll">
          {displayName}
        </h1>
      </div>

      {/* Main Content Area */}
      <div className="max-w-4xl mx-auto px-4 lg:px-6 py-6" data-id="element-2034" data-mp="2sxjxs1yov93t">
        <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden p-6 md:p-8" data-id="element-2035" data-mp="2xx6a896p0lbk">
          <h2 className="text-center text-lg font-bold text-slate-900 mb-6" data-id="element-2036" data-mp="1hiolgmniljqf">
            {displayName}
          </h2>

          {submitted && <div className={`border rounded-lg p-5 mb-6 text-sm shadow-sm ${passed ? 'border-green-200 bg-green-50/50' : 'border-red-200 bg-red-50/50'}`} data-id="element-2037" data-mp="1mjubudtpcuws">
              <p className={`font-bold mb-3 text-base ${passed ? 'text-green-800' : 'text-red-800'}`} data-id="element-2038" data-mp="rbcqbw5k2y9t">
                {passed ? 'Congratulations! You passed the final exam.' : 'You did not pass the final exam.'}
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-2039" data-mp="3m9yjvh7jp1l">
                <div className="bg-white p-3 rounded border border-slate-100" data-id="element-2040" data-mp="8ebjs6wcsq3r">
                  <p className="text-slate-500 text-xs uppercase tracking-wider font-semibold mb-1" data-id="element-2041" data-mp="3qrripi770b9j">
                    Total Questions
                  </p>
                  <p className="text-xl font-bold text-slate-900" data-id="element-2042" data-mp="3utw63z71sbnq">
                    {examQuestions.length}
                  </p>
                </div>
                <div className="bg-white p-3 rounded border border-slate-100" data-id="element-2043" data-mp="3lsescnh44m27">
                  <p className="text-slate-500 text-xs uppercase tracking-wider font-semibold mb-1" data-id="element-2044" data-mp="326wih22vexzv">
                    Correct Answers
                  </p>
                  <p className={`text-xl font-bold ${passed ? 'text-green-600' : 'text-red-600'}`} data-id="element-2045" data-mp="2x9csx60q2ysm">
                    {correctCount}
                  </p>
                </div>
                <div className="bg-white p-3 rounded border border-slate-100" data-id="element-2046" data-mp="374occ1n2su6p">
                  <p className="text-slate-500 text-xs uppercase tracking-wider font-semibold mb-1" data-id="element-2047" data-mp="3l4frw6t8qimt">
                    Final Score
                  </p>
                  <p className={`text-xl font-bold ${passed ? 'text-green-600' : 'text-red-600'}`} data-id="element-2048" data-mp="3uvaghhtylubf">
                    {score}%
                  </p>
                </div>
              </div>
            </div>}

          <p className="text-sm font-bold text-slate-900 mb-4" data-id="element-2049" data-mp="7r40vx58ujvn">
            The final exam requires an 80% pass rate. Good luck!
          </p>

          {/* Section Review */}
          <div className="mb-8" data-id="element-2050" data-mp="ats17jkbb8f0">
            <p className="text-sm text-slate-600 mb-1" data-id="element-2051" data-mp="aqco2ma789g8">Section Review</p>
            <select value={sectionReview} onChange={e => {
            const val = e.target.value;
            setSectionReview(val);
            if (val) {
              navigate(`/student/class/${slug}/content?section=${val}`);
            }
          }} className="border border-slate-300 rounded px-2 py-1 text-xs text-slate-700 bg-white" data-id="element-2052" data-mp="fs1xjxhrwf27">
              <option value="" data-id="element-2053" data-mp="yk4ihl1g6hi9">Select One</option>
              <option value="1" data-id="element-2054" data-mp="13guyk8d95d3o">Section 1</option>
              <option value="2" data-id="element-2055" data-mp="13f1sovagqwwq">Section 2</option>
              <option value="3" data-id="element-2056" data-mp="18gh8o8xsad89">Section 3</option>
              <option value="4" data-id="element-2057" data-mp="18dv4mja3qfus">Section 4</option>
              <option value="5" data-id="element-2058" data-mp="359j5arp3uio7">Section 5</option>
              <option value="6" data-id="element-2059" data-mp="35au7in2wjid7">Section 6</option>
            </select>
          </div>

          {/* Questions */}
          <div className="space-y-8" data-id="element-2060" data-mp="1rcg53ec4gc5o">
            {examQuestions.map((q, qi) => {
            const userAnswer = answers[qi];
            const isCorrect = userAnswer === q.correctAnswer;
            const isUnanswered = !userAnswer;
            return <div key={qi} id={`exam-q-${qi}`} className={`space-y-3 p-5 rounded-lg border transition-colors ${submitted && !isCorrect ? 'bg-red-50 border-red-200' : 'bg-slate-50 border-slate-100'}`} data-id="element-2061" data-mp="1ike85q19he05" data-mpi={qi}>
                  <div className="flex items-start gap-2" data-id="element-2062" data-mp="26b1tbd06u04n">
                    <span className="flex-shrink-0 flex items-center justify-center w-6 h-6 rounded-full bg-purple-100 text-purple-700 text-xs font-bold mt-0.5" data-id="element-2063" data-mp="21ads5yi8w2wp">
                      {qi + 1}
                    </span>
                    <p className="text-sm font-bold text-slate-900 leading-relaxed" data-id="element-2064" data-mp="pvqry8vddetg">
                      {q.question}
                    </p>
                    {submitted && <span className={`flex-shrink-0 flex items-center justify-center w-6 h-6 rounded-full ml-auto ${isCorrect ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`} data-id="element-2065" data-mp="28tbwyw4f94d4">
                        {isCorrect ? '✓' : '✗'}
                      </span>}
                  </div>
                  <div className="space-y-2 pl-8" data-id="element-2066" data-mp="24rqdgrxdtrty">
                    {q.options.map(opt => <label key={opt.letter} className={`flex items-start gap-3 cursor-pointer text-sm p-3 rounded-md border transition-colors ${userAnswer === opt.letter.toLowerCase() ? 'bg-purple-50 border-purple-200' : 'bg-white border-slate-200 hover:border-purple-300'}`} data-id="element-2067" data-mp="2shueqsn3lfhs">
                        <input type="radio" name={`exam-q-${qi}`} value={opt.letter.toLowerCase()} checked={userAnswer === opt.letter.toLowerCase()} onChange={e => handleAnswer(qi, e.target.value)} disabled={submitted} className="w-4 h-4 mt-0.5" style={{
                    accentColor: '#4A2D8F'
                  }} data-id="element-2068" data-mp="1736sh9ayxx6n" />
                        <span className="text-slate-700 leading-relaxed" data-id="element-2069" data-mp="kvavys6lg2ft">
                          <strong className="text-slate-900" data-id="element-2070" data-mp="kvkpuquretqs">
                            {opt.letter}.
                          </strong>{' '}
                          {opt.text}
                        </span>
                      </label>)}
                  </div>
                </div>;
          })}
          </div>

          {/* Submit Action */}
          {!submitted && <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-2071" data-mp="22gpynqy7knq">
              <button onClick={handleSubmit} className="px-6 py-2.5 text-sm font-bold rounded-md text-white hover:opacity-90 shadow-sm transition-colors" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-2072" data-mp="3tacooidkkkh5">
                Submit
              </button>
              <p className="text-xs text-slate-500 mt-2" data-id="element-2073" data-mp="2705e74fszl3m">
                All {examQuestions.length} questions must be answered to submit.
              </p>
            </div>}

          {submitted && passed && <div className="mt-8 pt-6 border-t border-slate-200 flex justify-end" data-id="element-2074" data-mp="1j7ot0l0rrd03">
              <Link to="/student/dashboard" className="px-6 py-2.5 text-sm font-bold text-white rounded-md shadow-sm hover:opacity-90 transition-opacity" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-2075" data-mp="1o7b87005r3bj">
                Return to Dashboard
              </Link>
            </div>}
        </div>
      </div>

      {/* Unanswered Questions Modal */}
      {showUnansweredModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" onClick={() => setShowUnansweredModal(false)} data-id="element-2076" data-mp="s2sxue1vjhs6">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-2077" data-mp="j73h4ibdfbl4">
            <div className="px-5 py-4 flex items-center justify-between" style={{
          backgroundColor: '#CC0000'
        }} data-id="element-2078" data-mp="9aqeguxulne8">
              <div className="flex items-center gap-2 text-white" data-id="element-2079" data-mp="9iqb5p1q2xv">
                <AlertCircleIcon className="h-5 w-5" data-id="element-2080" data-mp="9skl5h4iw9d" />
                <h3 className="text-base font-bold" data-id="element-2081" data-mp="3rgll0743ercu">Unanswered Questions</h3>
              </div>
              <button onClick={() => setShowUnansweredModal(false)} className="text-white/80 hover:text-white" data-id="element-2082" data-mp="1untino4unf8e">
                <XIcon className="h-5 w-5" data-id="element-2083" data-mp="1pmma3muvuc0o" />
              </button>
            </div>
            <div className="p-5 space-y-3" data-id="element-2084" data-mp="yjwcxm4dbunf">
              <p className="text-sm text-slate-700" data-id="element-2085" data-mp="13ipimsdeyhd1">
                You must answer <strong data-id="element-2086" data-mp="13k0mes6uzp45">all questions</strong> before submitting
                the final exam.
              </p>
              <div className="bg-red-50 border border-red-200 rounded-md p-3" data-id="element-2087" data-mp="tsecr0a65y3i">
                <p className="text-xs font-semibold text-red-800 mb-2" data-id="element-2088" data-mp="tqbgvzmc5aqv">
                  {unansweredList.length} question
                  {unansweredList.length === 1 ? '' : 's'} still need
                  {unansweredList.length === 1 ? 's' : ''} an answer:
                </p>
                <div className="flex flex-wrap gap-1.5" data-id="element-2089" data-mp="5wa15qkzljph">
                  {unansweredList.map(n => <button key={n} onClick={() => scrollToQuestion(n)} className="px-2.5 py-1 text-xs font-bold rounded bg-white border border-red-300 text-red-700 hover:bg-red-100 transition-colors" data-id="element-2090" data-mp="avmm25sasgpf">
                      Q{n}
                    </button>)}
                </div>
                <p className="text-xs text-slate-600 mt-2" data-id="element-2091" data-mp="3ks2azf26omqf">
                  Click any question number to jump to it.
                </p>
              </div>
              <div className="flex justify-end pt-1" data-id="element-2092" data-mp="3uo59maxtu38m">
                <button onClick={() => setShowUnansweredModal(false)} className="px-4 py-2 text-sm font-bold text-white rounded-md hover:opacity-90" style={{
              backgroundColor: '#4A2D8F'
            }} data-id="element-2093" data-mp="3umlski4cjo5s">
                  Got it
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}